var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRednode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.205078 7.3099H4.87174M4.87174 7.3099C4.87174 6.69106 5.11758 6.09756 5.55516 5.65998C5.99275 5.22239 6.58624 4.97656 7.20508 4.97656C7.82392 4.97656 8.41741 5.22239 8.85499 5.65998C9.29258 6.09756 9.53841 6.69106 9.53841 7.3099M4.87174 7.3099C4.87174 7.92873 5.11758 8.52223 5.55516 8.95981C5.99275 9.3974 6.58624 9.64323 7.20508 9.64323C7.82392 9.64323 8.41741 9.3974 8.85499 8.95981C9.29258 8.52223 9.53841 7.92873 9.53841 7.3099M9.53841 7.3099H14.2051",
    stroke: "#F54900",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRednode);
export default __webpack_public_path__ + "static/media/rednode.f0eddfbe460bdac7e171ade6a30db72e.svg";
export { ForwardRef as ReactComponent };